export default __webpack_public_path__ + "static/media/Equity_iconlogo.766b799b.svg";